import type { IconNode } from '../types';

/**
 * @name house-off
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjEgMTUuM1Y5bC05LTctMi40IDEuOSIgLz4KICA8cGF0aCBkPSJtMiAyIDIwIDIwIiAvPgogIDxwYXRoIGQ9Ik02LjQgNi40IDMgOXYxMWEyIDIgMCAwIDAgMiAyaDE0YTIgMiAwIDAgMCAxLjgtMS4yIiAvPgogIDxwYXRoIGQ9Ik0xMiAxMkg5djEwIiAvPgogIDxwYXRoIGQ9Ik0xNSAyMnYtNyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/house-off
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const houseOff: IconNode = [
  ['path', { d: 'M21 15.3V9l-9-7-2.4 1.9', key: 'o211tv' }],
  ['path', { d: 'm2 2 20 20', key: '1ooewy' }],
  ['path', { d: 'M6.4 6.4 3 9v11a2 2 0 0 0 2 2h14a2 2 0 0 0 1.8-1.2', key: '1ld7vm' }],
  ['path', { d: 'M12 12H9v10', key: 'm1m44x' }],
  ['path', { d: 'M15 22v-7', key: 'dfmlq7' }],
];

export default houseOff;
